const types = {
  SET_IS_SHOW_BUTTON: "SET_IS_SHOW_BUTTON",
};

export default types;